<template>
        <div>
                <HeadDetailsGama :titleHead="'Detalhes Consulta de Comissões'"></HeadDetailsGama>
                <div id="body-details" class="ml-2">
                        <p class="title-1">
                                Forma de Pagamento: {{ selectedComissao.proposta.formaPagamento }}
                        </p>
                        <div class="gap d-flex">
                                <div class="imovel-entrada">
                                        <p class="label-details">Valor Total do Imóvel</p>
                                        <input class="input-details"
                                                v-model="selectedComissao.proposta.valorTotalFormatado" disabled />
                                </div>
                                <div class="imovel-entrada">
                                        <p id="label-details">Entrada 10%</p>
                                        <input class="input-details" disabled
                                                v-model="selectedComissao.proposta.valorEntradaFormatado" />
                                </div>
                                <div class="incc">
                                        <p id="label-details">10% na Entrega corrigindo pelo INCC</p>
                                        <input disabled class="input-details"
                                                v-model="selectedComissao.proposta.valorEntregaFormatado" />
                                </div>
                        </div>
                        <div class="gap margin d-flex">
                                <div class="baloes-parcelar">
                                        <p class="label-details">
                                                Parcelas Balões Anuais com Reajuste Mensal
                                        </p>
                                        <input disabled class="input-details"
                                                v-model="selectedComissao.proposta.valorBalaoFormatado" />
                                </div>
                                <div class="baloes-parcelar">
                                        <p class="label-details">
                                                Parcelas Mensais Consecutivas com Reajuste Mensal
                                        </p>
                                        <input class="input-details" disabled
                                                v-model="selectedComissao.proposta.valorMensalFormatado" />
                                </div>
                        </div>
                        <p class="pt-4 subtitle">Empreendimento</p>
                        <div class="gap d-flex">
                                <div class="baloes-parcelar">
                                        <p class="label-details">Nome do Empreendimento</p>
                                        <input class="input-details" v-model="selectedComissao.empreendimento.nome" disabled />
                                </div>
                                <div class="baloes-parcelar">
                                        <p class="label-details">Cidade</p>
                                        <input class="input-details"
                                                v-model="selectedComissao.empreendimento.cidade.nome" disabled />
                                </div>
                                <div class="baloes-parcelar">
                                        <p class="label-details">Rua</p>
                                        <input class="input-details" disabled
                                                v-model="selectedComissao.empreendimento.endereco" />
                                </div>
                        </div>
                        <div class="gap margin d-flex">
                                <div class="numero-apartamento ">
                                        <p class="label-details">CEP</p>
                                        <input class="input-details" disabled
                                                v-model="selectedComissao.empreendimento.cep" />
                                </div>
                                <div class="incc">
                                        <p class="label-details">Bairro</p>
                                        <input class="input-details" disabled
                                                v-model="selectedComissao.empreendimento.bairro" />
                                </div>
                                <div class="numero-apartamento">
                                        <p class="label-details">Número</p>
                                        <input class="input-details" disabled
                                                v-model="selectedComissao.empreendimento.numero" />
                                </div>
                                <div class="torre">
                                        <p class="label-details">Torre</p>
                                        <input class="input-details" disabled
                                                v-model="selectedComissao.proposta.empreendimentoUnidade.grupo" />
                                </div>
                                <div class="numero-apartamento">
                                        <p class="label-details">Apartamento</p>
                                        <input class="input-details" disabled
                                                v-model="selectedComissao.proposta.empreendimentoUnidade.unidade" />
                                </div>

                        </div>
                </div>
        </div>
</template>
<script>
import SalesinformationAdm from './salesinformationAdm'
export default SalesinformationAdm
</script>

<style scoped>
.gap {
    column-gap: 10px;
}
.numero-apartamento {
        width: 40%;
}
.torre {
    width: 10%;
}
.margin {
    margin-top: 1rem;
}
.baloes-parcelar {
    width: 50%;
}
.imovel-entrada{
    width: 70%;
}
.incc{
    width: 100%;
}
#body-details{
    height: 100%;
    padding-bottom: 5%;
}
.subtitle{
    font-size: 18px;
    color: #008148;
    font-weight: bold;
    margin-bottom: 15px;
}
.input-details{
    width: 100%;
    height: 35px;
    padding-left: 10px;
    background-color: #F1F1F1;
    border: 1px solid #D4D9DE;
    border-radius: 5px;
}

#input-group-valorTotal{
    grid-row: 2;
    grid-column: 1;
    font-size: 15px;
    font-weight: 500;
    width: 200px;
}
#input-group-valorEntrada{
    grid-row: 2;
    grid-column: 2;
    font-size: 15px;
    font-weight: 500;
    width: 200px;
}

#input-group-valorEntrega{
    grid-row: 2;
    grid-column: 3;
    font-size: 15px;
    font-weight: 500;
    width: 200px;
    word-break: normal;
}
.container-user-form{
    display: grid;
    column-gap: 10px;
    row-gap: 10px;
    justify-content: center;
    grid-template-rows: 10% 1fr 1fr 10% 1fr 1fr;
    grid-template-columns: repeat(10,1fr);
}
.input-details {
    width: 100%;
    height: 35px;
    background-color: #F1F1F1;
    border: 1px solid #D4D9DE;
    border-radius: 5px;
}
.title-1{
  grid-row: 1;
  grid-column: 1/5;
  color: #008148;
  font-size: 19px;
  margin-top: 20px;
  font-weight: 800;
}
</style>



// WEBPACK FOOTER //
// src/views/private/realestate/commissions/components/salesinformationAdm/salesinformationAdm.vue